import { useUserProfile } from './useUserProfile';
import { UserScope } from '../types/auth.types';

export const usePermissions = () => {
  const {
    permissions,
    hasScope,
    hasAnyScope,
    hasAllScopes,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    hasEffectiveAccess,
    hasAnyEffectiveAccess,
    hasAllEffectiveAccess,
    directorySession,
    directoryError,
  } = useUserProfile();

  return {
    ...permissions,
    hasScope,
    hasAnyScope,
    hasAllScopes,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    hasEffectiveAccess,
    hasAnyEffectiveAccess,
    hasAllEffectiveAccess,
    directorySession,
    directoryError,
  };
};

export const useAlertPermissions = () => {
  const { canReadAlerts, canCreateAlerts, canSendAlerts } = usePermissions();

  return {
    canReadAlerts,
    canCreateAlerts,
    canSendAlerts,
    canManageAlerts: canCreateAlerts || canSendAlerts,
  };
};

/** Check de capability de UI (permission de GET /me). */
export const useScopeCheck = (scope: UserScope) => {
  const { hasEffectiveAccess } = useUserProfile();
  return hasEffectiveAccess(scope);
};

export const useMultipleScopeCheck = (scopes: UserScope[], requireAll = false) => {
  const { hasAnyEffectiveAccess, hasAllEffectiveAccess } = useUserProfile();
  return requireAll ? hasAllEffectiveAccess(scopes) : hasAnyEffectiveAccess(scopes);
};

/** Sesión de producto erlia-auth (GET /me). */
export const useDirectorySession = () => {
  const {
    directorySession,
    directoryError,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    isLoading,
  } = useUserProfile();

  return {
    directorySession,
    directoryError,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    isLoading,
  };
};

export const usePermissionCheck = (code: string) => {
  const { hasEffectiveAccess } = useUserProfile();
  return hasEffectiveAccess(code);
};
